
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const data = [
  { category: 'Assets', duration: 3.85, value: 100 },
  { category: 'Liabilities', duration: 2.60, value: 100 },
  { category: 'Gap', duration: 1.25, value: 100 },
];

const DurationGapChart = () => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
        layout="vertical"
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis type="number" domain={[0, 5]} />
        <YAxis type="category" dataKey="category" />
        <Tooltip 
          formatter={(value, name, props) => [value, 'Duration']}
          labelFormatter={(label) => `${label}`}
        />
        <Legend />
        <Bar dataKey="duration" name="Duration (Years)" fill="#3b82f6" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default DurationGapChart;
